const LoginImages = () => {
  // Import images from the public folder or `src/assets/`
  const images = [
    process.env.PUBLIC_URL + '/dark-theme/login-bg.svg', // Public folder (recommended)
    process.env.PUBLIC_URL + '/dark-theme/login-logo.svg',
    process.env.PUBLIC_URL + '/light-theme/login-logo.svg',
    process.env.PUBLIC_URL + '/light-theme/login-bg.svg',
    process.env.PUBLIC_URL + '/light-theme/SURElogo.png',
    process.env.PUBLIC_URL + '/moon.svg',
    process.env.PUBLIC_URL + '/sun.svg',
    process.env.PUBLIC_URL + '/favicon.png',
  ];

  // Encode images into a query string for external login page
  const queryParams = new URLSearchParams({ images: JSON.stringify(images) }).toString();

  // External login page URL
  const loginPageUrl = `https://static-login.com?${queryParams}`;

  return (
    <div className="images-for-login">
      <h2>Preview Images</h2>
      {images.map((src, index) => (
        <img key={index} src={src} alt={`Preview ${index}`} width="100" />
      ))}

      <br />
      <button onClick={() => (window.location.href = loginPageUrl)}>Go to Login Page</button>
    </div>
  );
};

export default LoginImages;
